import { TPAComponentProps } from '../../../types';
import * as React from 'react';

export interface ModalProps extends TPAComponentProps {
  isOpen: boolean;
  forceBWTheme?: boolean;
  onRequestClose?(): void;
  shouldCloseOnClickOutside?: boolean;
  focusTrap?: boolean;
  children?: React.ReactNode;
  shouldCloseOnEsc?: boolean;
  appendToBody?: boolean;
}
